var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0311 11.3335H11.9676C12.3533 11.3335 12.666 10.964 12.666 10.5081L12.666 3.49223C12.666 3.03637 12.3533 2.66683 11.9676 2.66683H6.0311C5.64537 2.66683 5.33268 3.03637 5.33268 3.49223L5.33268 10.5081C5.33268 10.964 5.64537 11.3335 6.0311 11.3335Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 13.3335L4.13398 13.3335C3.92181 13.3335 3.71833 13.2422 3.5683 13.0797C3.41827 12.9171 3.33398 12.6967 3.33398 12.4668L3.33398 4.66683",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCopy;